import styled from 'styled-components'
import { MEDIA } from 'utils'
import ShoppingBag from 'static/icons/shopping-bag.svg'

// Media query
const { MOBILE_UP, MOBILE } = MEDIA

export const ContainerArea = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 350;
`

export const Area = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--the-white);
  width: 100%;
  height: 8.8rem;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08);
  padding: 0 16px;
  @media screen and ${MOBILE} {
    height: 62px;
    border-bottom: none;
    padding: 0;
  }
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-width: 1140px;
  align-items: center;
  justify-content: space-between;
  margin: 0 16px;
  @media screen and ${MOBILE} {
    padding: 0 15px;
  }
`

export const HeaderLinks = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LinkContainer = styled.div`
  display: flex;
  margin: 0;
  height: 40px;
  align-items: center;
  font-family: var(--primary-font);
  font-size: 15px;
  font-weight: normal;
  line-height: 20px;

  & > a {
    color: var(--cobasi-blue-light-8);
    text-decoration: none;
  }

  @media screen and ${MOBILE_UP} {
    padding: 1rem;
    margin-top: 0;
    margin-right:30px;

    &:last-child{
      margin-right:0;
    }

  }

  ${props => props.mobileOnly && `
    @media screen and ${MOBILE_UP} {
      display: none !important;
    }
  `}
`

export const StyledShoppingBag = styled(ShoppingBag)`
  path {
    fill: var(--cobasi-blue-light-8);
  }
`

export const Explore = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--cobasi-blue-light-8);
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  font-family: var(--primary-font);

  a {
    color: inherit;
    text-decoration: none;

    :active {
        transition: 0.1s;
        opacity: 0.3;
    }

    :hover {
        transition: 0.3s;
        opacity: 0.8;
    }
  }
`
